module.exports = __webpack_public_path__ + "img/726F5B_A09C88_8B8C7B_94907C-256px.ac00ebd7.png";